import { Tabs } from "antd";

import PageBuilding from "./components/PageBuilding/PageBuilding";
import PageFloor from "./components/PageFloor/PageFloor";
import PageRoom from "./components/PageRoom/PageRoom";
import PageSubject from "./components/PageSubject/PageSubject";
import PageDepartment from "./components/PageDepartment/PageDepartment";
import PageRate from "./components/PageRate/PageRate";
import PageSection from "./components/PageSection/PageSection";
import PageSchoolYear from "./components/PageSchoolYear/PageSchoolYear";

export default function PageSystemSettingsGeneral() {
	const tabListTitle = [
		{
			key: "2",
			label: "Building",
			children: <PageBuilding />,
			id: "Building",
		},
		{
			key: "3",
			label: "Floor",
			children: <PageFloor />,
		},
		{
			key: "4",
			label: "Room",
			children: <PageRoom />,
		},
		{
			key: "5",
			label: "Department",
			children: <PageDepartment />,
		},
		{
			key: "8",
			label: "School Year",
			children: <PageSchoolYear />,
		},

		{
			key: "9",
			label: "Section",
			children: <PageSection />,
		},
		{
			key: "10",
			label: "Subject",
			children: <PageSubject />,
		},
		{
			key: "12",
			label: "Rate",
			children: <PageRate />,
		},
	];

	const onChange = (key) => {
		console.log(key);
	};

	return (
		<Tabs
			defaultActiveKey="1"
			onChange={onChange}
			type="card"
			items={tabListTitle}
		/>
	);
}
